import { Api } from "../axios-config";

export interface ICertificado {
  _id?: string;
  codigoCTR: string;
  aluno: string;
  pdfId?: string;
  cursoId?: string;
  curso?: {
    _id: string;
    Name: string;
    Hours: number;
  };
}

export interface ILead {
  _id: string;
  nome: string;
  telefone: string;
  serie: string;
  turno: string;
  escola: string;
  codigo: string;
  desconto: string;
}

export const CertificadosServices = {
  getByCTR: async (codigoCTR: string): Promise<ICertificado | Error> => {
    try {
      const { data } = await Api.get(`/certificados/search?search=${codigoCTR}`);
      
      console.log('Resposta da API:', data); // Debug
      
      // A API retorna diretamente um array de certificados
      if (data && Array.isArray(data) && data.length > 0) {
        // Retorna o primeiro certificado encontrado
        return data[0];
      } else {
        return new Error('Certificado não encontrado');
      }
    } catch (error) {
      console.error('Erro ao buscar certificado:', error);
      return new Error((error as { message: string }).message || "Erro ao buscar certificado");
    }
  },

  getLeadByCodigo: async (code: string): Promise<ILead | Error> => {
    try {
      const { data } = await Api.post(`/leads/code`, { code });
      
      console.log('Resposta da API:', data); // Debug
      
      return data; // A API deve retornar um objeto lead diretamente
      
    } catch (error) {
      console.error('Erro ao buscar lead:', error);
      return new Error((error as { message: string }).message || "Erro ao buscar lead");
    }
  }
};
